/*
 * File: /src/helpers/file-download-helper.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Wednesday, 8th August 2018 5:11:50 pm
 * Last Modified: Friday, 21st September 2018 1:20:55 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */

export default () => {
    return new Promise(function(resolve, reject) {
        var element = document.createElement('div')
        element.innerHTML = '<input type="file">'
        var fileInput = element.firstChild

        fileInput.addEventListener('change', function() {
            var file = fileInput.files[0]

            if (file.name.match(/\.(json)$/)) {
                var reader = new FileReader()

                reader.onload = async function() {
                    resolve(reader.result)
                }

                reader.readAsText(file)
            } else {
                reject('File not supported .json files only')
            }
        })

        fileInput.click()
    })
}



// WEBPACK FOOTER //
// ./src/helpers/file-upload-helper.js